import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import configureStore from './redux/store';
import reportWebVitals from './reportWebVitals';
import LocalStorage from './services/storage';
import { fetchUtilities } from './redux/slices/utility';
import { TOKEN_COOKIE } from './services/constants';
import { fetchAuthUser } from './redux/slices/account';
import { togglePreloading } from './redux/slices/setting';

import 'react-datepicker/dist/react-datepicker.css';
import 'react-confirm-alert/src/react-confirm-alert.css';
import 'jsvectormap/dist/jsvectormap.css';
import 'ckeditor5/ckeditor5.css';
import './assets/scss/themes.scss';

const storage = new LocalStorage();
const store = configureStore();

const root = ReactDOM.createRoot(document.getElementById('root'));

store.dispatch(fetchUtilities());

if (storage.getItem(TOKEN_COOKIE)) {
	store.dispatch(fetchAuthUser());
} else {
	store.dispatch(togglePreloading(false));
}

root.render(
	<React.StrictMode>
		<Provider store={store}>
			<BrowserRouter>
				<App />
			</BrowserRouter>
		</Provider>
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
